// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-all-selector {\n\tmargin: 0.5rem;\n\tdisplay: block;\n}\n.select-all-indented {\n\tmargin-left: 1.5rem;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
